import {useQueryClient, useMutation} from 'react-query'
import {QUERIES} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {mergeFiles} from '../../core/_requests'
import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import { useCompanies } from '../../../../../auth/core/Companies'

const EmbeddignsListGrouping = () => {
  const {selected, clearSelected} = useListView()
  const [mergingLoad, setMergingLoad] = useState(false)
  const queryClient = useQueryClient()
  const {query} = useQueryResponse()
  const navigate = useNavigate()
  const {defaultCompany} = useCompanies()

  const deleteSelectedItems = async () => {

    const data= await mergeFiles(selected,defaultCompany?.company_id);
    console.log(data);
    clearSelected()
    navigate('/merging',{state:data})
  }

  return (
    <div className='d-flex justify-content-end align-items-center'>
      <div className='fw-bolder me-5'>
        <span className='me-2'>{selected.length}</span> Selected
      </div>

      {(selected.length>1 ? <button
        type='button'
        className='btn btn-primary me-2'
        disabled={mergingLoad}
        onClick={async () => {
          setMergingLoad(true)
          await deleteSelectedItems()
        }}
      >
        {mergingLoad ? (
          <>
            <div className='spinner-border spinner-border-sm' role='status'>
              <span className='visually-hidden'></span>
            </div>{' '}
               Merging...
          </>
        ) : (
          'Merge Selected'
        )}
      </button> : <></>)}
     
    </div>
  )
}

export {EmbeddignsListGrouping}
